<template>
<div class="col essential-reading"> 
    <h3 class="section-heading" v-html="section.name"></h3> 
    <ul class="items">
        <template v-for="(post, rindex) in section.posts" >
            <li class="item" :key="post.id" v-if="(rindex+1) <= section.item_limit"> 
                <div class="item-title"><a :href="post.url" :target="hrefTarget"> {{post.title}} </a></div> 
                <div class="item-author" :class="{'block': (issue.parent_issue_id == null)}" > {{post.byline}} </div>
                <div class="excerpt">{{post.excerpt}}</div> 
                <div v-if="post.type == 'charticle' || post.type == 'summary'">
                    <div class="link">
                        <a :href="post.url + '#summary'" :target="hrefTarget">Summary</a>
                    </div> 
                    <div class="link" v-if="post.has_charticle == 1">
                        <a :href="post.url + '#charticle'" :target="hrefTarget">Charticle</a>
                    </div>
                </div>
            </li>
        </template>
    </ul>
    <div v-if="section.item_limit < section.posts.length" 
        class="load-more" @click="displayMorePostsForSection(section)">Load More</div>
</div><!--End of essential reading-->
</template>

<script>

import SectionsMixin from './SectionsMixin.js';

export default {
    name: 'startup-news',
    mixins: [
        SectionsMixin,
    ],
}
</script>